import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Effect, Actions } from '@ngrx/effects'
import { BackService } from '../services'
import { Action, User, State, LogIn, Types, of, Observable, Api, TokenName, Todo, AlertContent } from './app.model'

@Injectable()

export class AppEffects {

  @Effect() getTodos: Observable<Action> = this.actions.ofType(Types.getTodos).switchMap(() => {
    return this.bs.get(Api.operation.todo.get).map((rows: any): Action => ({
      type: Types.getTodosSuccess,
      payload: { todos: rows.filter(x => !x.done).map(x => new Todo(x)) }
    })).catch(() => of<Action>({ type: Types.UpdateState, payload: {} }))
  })

  @Effect() logOut: Observable<Action> = this.actions.ofType(Types.logOut).map((): Action => {
    localStorage.removeItem(TokenName)
    return { type: Types.logOutSuccess }
  }).catch(() => of<Action>({ type: Types.UpdateState, payload: {} }))

  @Effect() logIn: Observable<Action> = this.actions.ofType(Types.logIn).switchMap((a: LogIn) => {
    const logInFailure: Action = {
      type: Types.UpdateState,
      payload: {
        alert: new AlertContent({
          snackbar: true,
          msg: '登陆失败，请检查店铺、用户名和密码',
          success: false
        })
      }
    }
    return this.bs.post(Api.auth.login, a.payload).map((data: any): Action => {
      if (data) {
        this.router.navigate(['/home'])
        return {
          type: Types.UpdateState,
          payload: { user: new User(data) }
        }
      } else {
        return logInFailure
      }
    }).catch(() => of(logInFailure))
  })

  constructor(
    private actions: Actions,
    private bs: BackService,
    private router: Router
  ) {}

}



// WEBPACK FOOTER //
// ./src/app/store/app.effects.ts